export default __webpack_public_path__ + "static/media/std-dev-icon.49193fef.svg";